<template>
  <div class="activityDetail">
    <div class="container">
      <div class="infoDetail">
        <div class="infoDetail_left">
          <img :src="baseurl + detail.img" alt="">
        </div>
        
        <div class="infoDetail_right">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="24">
              <div class="titel">
                <h4>{{ detail.title }}</h4>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动类型：{{ detail.publishTypeId  }}</p>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>发布时间：{{ detail.publishTime }} </p>
              </div>
            </el-col>
          
             <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="right_text">
                <p>活动简介：{{ detail.depict }}</p>
              </div>
            </el-col>
         
             <!-- <el-col :xs="24" :sm="24" :md="24">
              <div class="right_btn">
                <el-button @click="baoming">报名活动</el-button>
              </div>
            </el-col> -->
          </el-row>
        </div>
        
      </div>
    
      <div class="activityContent" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityDetail',
  data () {
    return {
      detail: {},
      baseurl: this.$baseurl
    }
  },
  mounted () {
    let { id } = this.$route.query
    this.getactivityDetail(id)
  },
  methods: {
    async getactivityDetail(id) {
      let { data: { data, code  }} = await this.$http.get('api/information/selectDetailById/' + id)
      if(code != 0) return
      this.detail = data
    },
    async baoming() {
      let userinfo = localStorage.getItem('userinfo')
      if(!userinfo) return this.$message.warning("请先登陆或注册！");
      let { id: userId, realName: userName } = JSON.parse(userinfo)
      let { id: activityId, activityName } = this.detail
      let dataform = { userId, activityName, activityId, userName }
      let { data: { code }} = await this.$http.post('/apply/apply', dataform)
      if (code == 500) return this.$message.warning("当前活动已报名,请勿重新报名！");
      if (code != 0) return this.$message.warning("报名失败！");
      this.$message.success("报名成功！");
    }
  }
}
</script>

<style lang="scss">
.activityDetail {
  padding: 30px 0;
  .infoDetail {
    width: 1100px;
    background-color: #f4f4f5;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    justify-content: center;
    .infoDetail_left {
      flex: 1;
      padding-right: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .infoDetail_right {
      flex: 3;
      .titel {
        h4 {
          font-size: 22px;
          font-weight: 500;
          line-height: 1.5;
        }
        padding-bottom: 10px;
      }
      .right_text p{
        font-size: 14px;
        line-height: 2;
      }
      .right_btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-button {
          background-color: #be9c59;
          color: #fff;
        }
      }
    }
  }
  .activityContent {
    padding: 30px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin: 0 auto;
    }
  }
}
</style>